if not App.angularApp?
    return

###
Apply to any text input. Replaces input with decimal (to the 10ths place) equivalent
Strips non digits.

Example of expected results where length = 3
input => result
0 => 0
0.0 => 0.0
0. => 0.
1 => 0.1
12 => 1.2
123 => 12.3
1234 => 12.3
1.2 => 1.2
12.3 => 12.3
12.33.4 => 12.3
asdf1 => 0.1
###
App.angularApp.directive 'mfForceDecimal', ['$parse', ($parse) ->
    return {
        restrict: 'A'
        require: 'ngModel'
        scope:
            mfForceDecimal: '=?'
        link: ($scope, elem, attrs, ngModel) =>

            # NOTE: what is returned from the $parser goes to the ngModel
            # If undefined is returned the value is considered invalid
            # https://code.angularjs.org/1.3.0-beta.9/docs/api/ng/type/ngModel.NgModelController

            $scope.mfForceDecimal ?= {}
            $scope.mfForceDecimal.digits ?= 3
            $scope.mfForceDecimal.places ?= 1

            ngModel.$parsers.unshift (viewValue) =>
                # If the typed value is not empty and not a form of 0
                # we will turn the entered value into a decimal number
                # and re-render the input
                if viewValue isnt '' and viewValue not in ['0', '0.', '0.0']

                    # store previous
                    previous = $scope.previous

                    # If it has changed
                    if viewValue isnt previous
                        # remove decimals and non digits
                        viewValue = String(viewValue).replace(/[\.\D]/g, '')

                        # concat if to many given
                        viewValue = viewValue.slice(0, $scope.mfForceDecimal.digits)

                        # divide by 10 to the power of mfForceDecimal.places
                        place = Math.pow(10, $scope.mfForceDecimal.places)
                        $scope.previous = parseFloat(viewValue / place).toFixed($scope.mfForceDecimal.places)

                        # Set viewValue, render html amd return
                        ngModel.$setViewValue($scope.previous)
                        ngModel.$render()
                        return $scope.previous

                # No change made, return typed value
                return viewValue
    }
]
